import React, { useState } from 'react';
import './analysis-tools.css';
import MultiVariantSearch from './analysistools/multi-variant-search';
import SingularNetwork from './analysistools/SingularNetwork';

function AnalysisTools() {
  const [activeTab, setActiveTab] = useState('mvs');

  return (
    <div className="OCRP-analysis-tools">
      <div className="OCRP-analysis-tabs">
        <button
          className={`OCRP-tab-button ${activeTab === 'mvs' ? 'OCRP-tab-active' : ''}`}
          onClick={() => setActiveTab('mvs')}
        >
          <i className="fas fa-network-wired"></i>
          <span>Multi-Network</span>
        </button>
        <button
          className={`OCRP-tab-button ${activeTab === 'network' ? 'OCRP-tab-active' : ''}`}
          onClick={() => setActiveTab('network')}
        >
          <i className="fas fa-project-diagram"></i>
          <span>Deep Network</span>
        </button>
      </div>

      <div className="OCRP-analysis-content">
        {activeTab === 'mvs' && <MultiVariantSearch />}
        {activeTab === 'network' && <SingularNetwork />}
      </div>
    </div>
  );
}

export default AnalysisTools;
